import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=8ce1f472&scoped=true&"
var script = {}
import style0 from "./menu.vue?vue&type=style&index=0&id=8ce1f472&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce1f472",
  null
  
)

export default component.exports